import { StepButton } from './tour.types';

export const Buttons = {
  next(text = 'Next', classes = 'shepherd-btn shepherd-btn-primary'): StepButton {
    return {
      text,
      classes,
      action: function (this: any) {
        this.next();
      }
    };
  },
  back(text = 'Back', classes = 'shepherd-btn'): StepButton {
    return {
      text,
      classes,
      action: function (this: any) {
        this.back();
      }
    };
  },
  finish(text = 'Finish', classes = 'shepherd-btn shepherd-btn-primary'): StepButton {
    return {
      text,
      classes,
      action: function (this: any) {
        this.complete();
      }
    };
  },
  skip(text = 'Skip', classes = 'shepherd-btn shepherd-btn-outline'): StepButton {
    return {
      text,
      classes,
      action: function (this: any) {
        this.cancel();
      }
    };
  }
};
